module.exports = __webpack_public_path__ + "code.1c8e22d2.png";